import React from 'react';
import CheckoutSectionHeader from './Checkout.SectionHeader';
import clsx from 'clsx';

interface CheckoutSectionProps {
  children?: any;
  className?: string;
  headerClassName?: string;
  title?: string;
  titleRight?: JSX.Element | string;
}

const CheckoutSection = ({
  children,
  className = '',
  title,
  titleRight,
  headerClassName,
}: CheckoutSectionProps) => {
  return (
    <div
      className={clsx(
        className,
        'bg-white',
        'rounded',
        'py-6',
        'px-4',
        'lg:p-6'
      )}
    >
      {title && (
        <CheckoutSectionHeader className={headerClassName}>
          <h4 className="uppercase">{title}</h4>
          {titleRight}
        </CheckoutSectionHeader>
      )}
      {children}
    </div>
  );
};

export default CheckoutSection;
